import { render, staticRenderFns } from "./EasyFooter.vue?vue&type=template&id=186c3c24&"
import script from "./EasyFooter.vue?vue&type=script&lang=js&"
export * from "./EasyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports